import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import FAQ from '../components/Home/FAQ'
import MainPreview from '../components/PreviewRequests/MainPreview'

const PreviewRequests = () => {
    return (
        <div className=''>
            <Navbar />
            <MainPreview />
            <FAQ />
            <Footer />
        </div>
    )
}

export default PreviewRequests